import { render } from "./contact-form.vue?vue&type=template&id=740a4a3e"
import script from "./contact-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./contact-form.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "740a4a3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('740a4a3e', script)) {
    api.reload('740a4a3e', script)
  }
  
  module.hot.accept("./contact-form.vue?vue&type=template&id=740a4a3e", () => {
    api.rerender('740a4a3e', render)
  })

}

script.__file = "resources/ts/components/contact/contact-form.vue"

export default script